var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{ref:"pie_chartdiv",staticClass:"hello",staticStyle:{"min-height":"150px"}}),_c('div',{staticClass:"pie-legend",attrs:{"id":'pie_legend_id_' + _vm.legend_id}})])}
var staticRenderFns = []

export { render, staticRenderFns }